import { useState, useEffect, useRef } from "react"
import Grid from "../components/Grid"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { Link } from "react-router-dom"
import Heading from "../components/Heading"

const Table = () => {
  const navigate = useNavigate()
  const { type, categoryName, subcategoryName } = useParams()
  const [categorySelect, setCategorySelect] = useState(categoryName)
  const [subcategorySelect, setSubcategorySelect] = useState(subcategoryName)
  const [queryParams, setQueryParams] = useSearchParams()
  const resetApiParams = {
    page: 0,
    itemsPerPage: 25,
    searchParams: '',
    sortingCols: [],
    filterCols: []
  }
  const [apiParams, setApiParams] = useState(resetApiParams)
  const gridRef = useRef(null)

  const resetTableQueryParams = () => {
    setApiParams(resetApiParams)
    document.getElementById("search-box").value = ''
  }

  useEffect(() => {
    if (categoryName !== categorySelect) {
      setSubcategorySelect('')
      resetTableQueryParams()
      navigate(`/table/category/${categorySelect}/all`)
    }
  }, [categorySelect])

  useEffect(() => {
    if (categorySelect && subcategorySelect) {
      resetTableQueryParams()
      navigate(`/table/category/${categorySelect}/${subcategorySelect}`)
    }
  }, [subcategorySelect])

  return (
    // Most of the HTML structure has been taken from CDIL website as of April 2024
    <div id="site">
      <div className="wrapper2 clear" id="yui_3_17_2_1_1714970186045_163">
        <div id="content">
          <div className="wrapper clear" data-content-field="main-content" id="yui_3_17_2_1_1714970186045_162">
            <div
              className="sqs-layout sqs-grid-12 columns-12"
              data-type="page"
              data-updated-on="1713004496481"
              id="page-5429503be4b0e1ecd7f5fd93"
            >
              <div className="row sqs-row">
                <div className="col sqs-col-12 span-12">
                  <div className="row sqs-row">
                    <div className="col sqs-col-12 span-6">
                      <div
                        className="sqs-block html-block sqs-block-html"
                        data-block-type="2"
                        data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1412164531582_12429"
                      >
                        <div className="sqs-block-content">
                          <div className="sqs-html-content">
                        
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Heading
                    categoryText={categorySelect !== 'all' ? categorySelect : null}
                    headingText={
                      (subcategorySelect && subcategorySelect !== 'all') ? subcategorySelect :
                        (categorySelect && categorySelect !== 'all') ? categorySelect : 'All Products'
                    }
                  />

                  <div className="row sqs-row">
                    <div className="col sqs-col-12 span-6">
                      <div className="sqs-block html-block sqs-block-html" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1412164531582_12429">
                        <div className="sqs-block-content">
                          <div className="sqs-html-content">
                            <Grid
                              categorySelect={categorySelect}
                              setCategorySelect={setCategorySelect}
                              subcategorySelect={subcategorySelect}
                              setSubcategorySelect={setSubcategorySelect}
                              apiParams={apiParams}
                              setApiParams={setApiParams}
                              gridRef={gridRef}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >
        </div >
      </div >
    </div >
  )
}

export default Table
